import { Link, useParams } from "react-router-dom";
import { PageHeader, Tabs } from "../components/ui";
import VersionsPanel from "../components/VersionsPanel";
import GitRemotePanel from "../components/GitRemotePanel";

/** Histórico completo de versões do projeto: /projects/:id/versions */
export default function VersionsPage() {
  const { id = "" } = useParams();

  return (
    <div className="space-y-4">
      <PageHeader
        title="Versões"
        description="Histórico de alterações, checkpoints, restauração e Git remoto opcional."
        actions={
          <Link to={`/projects/${id}/builder`} className="text-xs text-brand hover:underline">
            Voltar ao Builder
          </Link>
        }
      />
      <Tabs
        items={[
          { id: "history", label: "Histórico", content: <VersionsPanel projectId={id} /> },
          { id: "remote", label: "Git remoto", content: <GitRemotePanel projectId={id} /> },
        ]}
      />
    </div>
  );
}
